import type { GatsbyBrowser } from "gatsby"
import "./src/styles/global.css"
import { trackAIReferral } from "./src/utils/ai-referrer-tracking"
import { captureAttribution, installLinkTracking } from "./gatsby-ui/lib/attribution"
import { pushPageContext, type PageTaxonomy } from "./gatsby-ui/lib/page-context"
import taxonomy from "./src/content/page-taxonomy.json"

// Performance optimization: Defer non-critical resources
export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  // Attribution (sites/RFC-004): links to the Autopilot app carry ft_*/lt_*/utm_*
  // at click time, and CTA clicks push cta_click to the dataLayer.
  installLinkTracking({ decorateHosts: ["autopilot.hunto.ai"] })

  // Brand font (Figtree 400/500/600/700) comes from gatsby-ui/styles/fonts.css with
  // font-display: swap; Figtree 400 and 600 are preloaded in gatsby-ssr.tsx.
}

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  // Track page views or perform actions on route change
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("config", "GA_MEASUREMENT_ID", {
      page_path: location.pathname,
    })
  }

  // First-touch / last-touch attribution cookie (hunto_attr)
  captureAttribution()

  // Track visits from AI-generated answers (ChatGPT, Perplexity, Gemini, etc.)
  trackAIReferral()

  // Scroll to top on route change (optional)
  // html has scroll-behavior: smooth, so a plain scrollTo animates and stalls mid-page.
  if (typeof window !== "undefined" && !location.hash) {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior })
  }
}

// Optimize initial load
export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] = () => {
  // Remove loading class or perform post-load optimizations
  if (typeof window !== "undefined") {
    document.body.classList.remove('loading')
  }
}

// Prefetch resources for better navigation
export const onPreRouteUpdate: GatsbyBrowser["onPreRouteUpdate"] = ({ location, prevLocation }) => {
  // The first page's context is inlined by gatsby-ssr; later navigations push theirs here.
  if (prevLocation) pushPageContext(taxonomy as unknown as PageTaxonomy, location.pathname)
  // Prepare for route change
  if (typeof window !== "undefined") {
    document.body.classList.add('route-transitioning')
  }
}

export const onRouteUpdateDelayed: GatsbyBrowser["onRouteUpdateDelayed"] = () => {
  // Handle delayed route updates
  console.log('Route update taking longer than usual')
}

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({ routerProps }) => {
  if (routerProps.location.hash) return true
  window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior })
  return false
}
